import React from 'react';
import LabelChip from './LabelChip';
import styles from './Labels.module.css';

interface LabelsProps {
  labels: Record<string, string>; // label name -> color
  onAddLabel?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  showAddButton?: boolean;
  removable?: boolean;
  onRemoveLabel?: (labelName: string) => void;
  isCurrentRound?: boolean;
}

const Labels: React.FC<LabelsProps> = ({ 
  labels, 
  onAddLabel, 
  showAddButton = false,
  removable = false,
  onRemoveLabel,
  isCurrentRound = true,
}) => {
  // Convert labels object to array and sort alphabetically
  const sortedLabelEntries = Object.entries(labels).sort(([a], [b]) => a.localeCompare(b));

  // If no labels and no add button, return null
  if (sortedLabelEntries.length === 0 && !showAddButton) {
    return null;
  }

  return (
    <div className={styles.labelsContainer}>
      {sortedLabelEntries.map(([label, color]) => (
        <LabelChip 
          key={label} 
          label={label} 
          color={color} 
          size="small" 
          removable={removable}
          onRemove={() => onRemoveLabel?.(label)}
          isCurrentRound={isCurrentRound}
        />
      ))}
      
      {showAddButton && (
        <button
          className={styles.addLabelChip}
          onMouseDown={onAddLabel}
          onClick={onAddLabel}
          title="Add label"
        >
          LABEL
        </button>
      )}
    </div>
  );
};

export default Labels; 